import * as React from 'react';
import clx from 'classnames';

import { Col, Row, Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import './DossierTableCellTitle.scss';
import {
  FileTextOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  PaperClipOutlined
} from '@ant-design/icons';
import { RequestResponseFileType } from 'common/schema/request/RequestResponseFileType';
import { assertNever } from 'server/utils/typings/assertNever';
import {
  IProcedureBridgeAttachmentInfo,
  IProcedureBridgeDocumentInfo
} from 'common/dto/ProcedureBridgeDto';
import { ResponsiveHide } from 'client/ui/responsive/ResponsiveHide';

export interface DossierTableCellTitleProps {
  name: string;
  type: RequestResponseFileType;
  opened?: boolean;
  readFlag?: React.ReactNode;
  actionsMobile?: React.ReactNode;
  document?:
    | IProcedureBridgeAttachmentInfo
    | IProcedureBridgeDocumentInfo
    | null;
  isAdmin?: boolean;
}

function renderIcon(target: RequestResponseFileType, opened?: boolean) {
  switch (target) {
    case RequestResponseFileType.Attachment:
      return <PaperClipOutlined />;
    case RequestResponseFileType.Document:
      return <FileTextOutlined />;
    case RequestResponseFileType.Dossier:
      return opened ? <FolderOpenOutlined /> : <FolderOutlined />;
    default:
      return assertNever(target);
  }
}

/**
 * Riga della tabella documenti contenente il Titolo/Nome
 * e l'icona del tipo relativa
 * con il feedback aperta/chiusa in caso di cartella
 */
export function DossierTableCellTitle(props: DossierTableCellTitleProps) {
  const documentIsRead =
    props.type !== RequestResponseFileType.Dossier
      ? props.document?.read
        ? true
        : false
      : false;
  return (
    <Row
      align="middle"
      className={clx('dossier-table-cell-title', {
        'is-dossier': props.type == RequestResponseFileType.Dossier
      })}
    >
      <Col
        flex="0 0 36px"
        className={clx('icon-cell', {
          'icon-dossier': props.type == RequestResponseFileType.Dossier
        })}
      >
        {props.isAdmin && props.readFlag}
        {renderIcon(props.type, props.opened)}
      </Col>
      <Col flex="1 1 0" className="title-cell">
        <Text strong={!documentIsRead}>{props.name}</Text>
      </Col>
      <ResponsiveHide mobileOnly breakPoint="sm" style={{ width: '100%' }}>
        {props.actionsMobile}
      </ResponsiveHide>
    </Row>
  );
}
